import { render, staticRenderFns } from "./projects-list.vue?vue&type=template&id=4358ae2b&scoped=true"
import script from "./projects-list.vue?vue&type=script&lang=js"
export * from "./projects-list.vue?vue&type=script&lang=js"
import style0 from "./projects-list.vue?vue&type=style&index=0&id=4358ae2b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4358ae2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4358ae2b')) {
      api.createRecord('4358ae2b', component.options)
    } else {
      api.reload('4358ae2b', component.options)
    }
    module.hot.accept("./projects-list.vue?vue&type=template&id=4358ae2b&scoped=true", function () {
      api.rerender('4358ae2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/projects/list/projects-list.vue"
export default component.exports